import { Alert, AlertTitle } from "@mui/material"
import { getHubspotDisabled } from "routes/sfg20-admin/plugins/system-tab/system-flags/controller/get-hubspot-disabled"

export function HubspotDisabledBanner() {
    // Uses the safe, non-admin isHubspotDisabled query so the banner shows for all users,
    // not just admins (it is mounted app-wide in BeforeRoute).
    const disabled = getHubspotDisabled.useResults()
    if (!disabled) return null

    return (
        <Alert
            severity="warning"
            sx={{
                borderRadius: 0,
                "& .MuiAlert-message": { width: "100%" },
            }}
        >
            <AlertTitle sx={{ mb: 0 }}>HubSpot Integration Disabled — Licences are being served from cache</AlertTitle>
        </Alert>
    )
}
